module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_a_una_tinta-72a8f42a064dd0c5c4ef870631228368.svg";